// extracted by mini-css-extract-plugin
export default {"action-button":"RemovePromoIcon--action-button--8TiQl","actionButton":"RemovePromoIcon--action-button--8TiQl"};